import { SET_LANDING_DATA } from '../actions/action-types';

const initialState = {
  data: null,
};

export default function landingReducer(state = initialState, action) {
  switch (action.type) {
    case SET_LANDING_DATA:
      return { ...state, data: action.payload };
    default:
      return state;
  }
}
